import { render } from "./Posts.vue?vue&type=template&id=3f52db66&scoped=true"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"

import "./Posts.vue?vue&type=style&index=0&id=3f52db66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f52db66"

export default script